var $ = jQuery;
function videoClickHandlerEmbedded(e) {
	e.preventDefault();
	var frame = $(e.data.embedHtml);
	frame.attr('src', frame.attr('src') + '&autoplay=1');
	$(this).parent().hide().parent().append(frame);
}


// Navigation height measure_________________________________________________________________________________________________
$(window).resize(function () {
	var navigationHeight = $('.navigation').outerHeight();
	$('#wrapper').css('margin-top', navigationHeight);
	$('.navigation__menu').css('top', navigationHeight);

});


$(document).ready(function () {

	$(window).trigger('resize');

	// Navigation menu_________________________________________________________________________________________________
	function openNavigation() {
		$('.navigation__menu').toggleClass('navigation__menu--active');

		$('.navigation__hamburger').addClass('fa-times');
	}

	function closeNavigation() {
		$('.navigation__hamburger').removeClass('fa-times');
		$(".navigation__menu").removeClass('navigation__menu--active');
	}


	$('.navigation__hamburger').on('click', function (e) {
		e.preventDefault();
		// Opening
		if (!$('.navigation__menu').hasClass('navigation__menu--active')) {
			openNavigation();
		} else {
			closeNavigation();
		}
	});

	var $navigation = $('.navigation__menu');

	$(document).on('click', function closeTooltip(element) {
		var target = $(element.target);
		if (!target.hasClass('fa-times')) {
			// Tracks all $navigation.has(element.target).length tracks the childs of the .navigation__menu
			if (!target.hasClass('navigation__menu--active') && $navigation.has(element.target).length === 0) {
				if (!target.hasClass('navigation__hamburger')) {
					closeNavigation();
				}
			}
		}
	});


		// Hide on esc key_________________________________________________________________________________________________
		document.onkeydown = function (evt) {
			evt = evt || window.event;
			if (evt.keyCode == 27) {
				 ($('.navigation__menu').hasClass('navigation__menu--active'))
					closeNavigation();
				}
		};


	// Hide navigation when scrolling down_________________________________________________________________________________________________
	function hasScrolled() {
		if ($('.navigation__menu').hasClass('navigation__menu--active')) {
			$('.navigation').removeAttr("style");
			return;
		} else {
			var st = $(this).scrollTop();
			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta)
				return;
			// If they scrolled down and are past the navbar, add minus top of navigation height.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > navbarHeight) {
				// Scroll Down
				$('.navigation').css('top', -navbarHeight);
			} else {
				// Scroll Up
				if (st + $(window).height() < $(document).height()) {
					$('.navigation').removeAttr("style")
				}
			}
			lastScrollTop = st;
		};
	}

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.navigation').outerHeight();

	$(window).scroll(function (event) {
		didScroll = true;
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);



	/******************************* NEW CODE ************************/

	$('.sidebarNavigation').on('click', '.submenu__accordion', function (e) {
		$(this).siblings('ul').slideToggle('fast');
		$(this).parent().toggleClass('showchildren');
		$(this).toggleClass('submenu__accordion--active');
	});

	// Append the span on page load to sidebar navigation
	$('.sidebarNavigation ul li.page_item_has_children').each(function () {
		$(this).prepend('<span class="submenu__accordion"></span>');
	})

	// Add active class on page load for the sidebar navigation
	$('.current_page_ancestor span').addClass('submenu__accordion--active');
	$('.current_page_item span').addClass('submenu__accordion--active');


	// Cookie disclaimer ==============================================================
	if (!Cookies.get('massRestCookie')) {
		$(".cookie").addClass("cookie--active");
	}

	$(".cookie__btn").click(function (e) {
		e.preventDefault();
		$(".cookie").fadeOut(100);
		Cookies.set('massRestCookie', 'accept', { expires: 365 });
		$(window).trigger('resize');
	});




	// Make iframes responsive
	$('iframe[src*="youtube"]').wrap('<div class="video"></div>');

	if (typeof rerenderFB !== 'undefined') { //override responsive script in facebook plugin thingie, since they don't give a shit about height
		var WHRatio = 1.29032258065; //magic number = height / width. Taken specifically from an image on the site that is 620 * 800 px.
		rerenderFB = function () {
			jQuery('.cameronjonesweb_facebook_page_plugin').each(function () {
				var container = jQuery(this).children('.fb-page');
				var wrapper = jQuery(this);
				var url = container.data('href');
				var width = wrapper.width();
				var max_width = container.data('max-width');
				var containerId = jQuery(this).attr('id');
				if (jQuery(container).data('adapt-container-width') == true) {
					container.fadeOut("slow", function () {
						if (width <= max_width) {
							container.attr("data-width", width);
						} else {
							container.attr("data-width", max_width);
						}
						container.attr('data-height', Math.floor(parseInt(container.attr('data-width')) * WHRatio));
						container.load(url, function () {
							FB.XFBML.parse(document.getElementById(containerId),
								function () {
									container.fadeIn("slow");
								});
						})
					});
				}
			});
		}

		//also initialize at first
		var container = $('.cameronjonesweb_facebook_page_plugin .fb-page');
		container.attr('data-height', Math.floor(container.closest('.col').width() * WHRatio));
	}




});



jQuery(window).load(function ($) {
	var cookieValue = jQuery.cookie("massrestCookie");
	if ("massrestCookieSet" != cookieValue) {
		jQuery('.cookie-disclaimer').delay(750).fadeIn(250);
	};
});





